import { FormControl as MuiFormControl, styled } from '@mui/material';

export const DetailsContainer = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  overflowY: 'auto',
  width: '100%',
  ...theme.styledScrollbar,
}));

// TODO: extract these Select styles to an updated shared
// Select component/Mui theme override
export const FormControl = styled(MuiFormControl)(({ theme }) => ({
  '& .MuiSelect-select': {
    color: theme.palette.primary.main,
    padding: '12px',

    '.MuiTypography-root': {
      fontFamily: theme.typography.bold.fontFamily,
    },
  },

  '& .MuiSelect-select.Mui-disabled': {
    borderColor: theme.palette.grey[200],

    '.MuiTypography-root': {
      '-webkit-text-fill-color': theme.palette.grey[600],
      fontFamily: theme.typography.fontFamily,
    },
  },

  '.MuiOutlinedInput-root.Mui-disabled fieldset.MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200],
  },

  '.MuiSelect-icon': {
    color: theme.palette.primary.main,
    transition: 'transform 0.3s',
  },

  '.MuiSelect-iconOpen': {
    transform: 'rotate(180deg)',
  },
}));
